(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initHeaderDropdown();
    initAccordions();
    initProductGallery();
    initVariantPickers();
    initCollectionControls();
    initMoodPicker();
    initCartPage();
    normalizeRupeeSymbols();
  });

  /* ---------------- Header Mega Dropdown ---------------- */
  function initHeaderDropdown() {
    document.querySelectorAll("[data-kj-dropdown]").forEach(function (container) {
      var btn = container.querySelector(".kj-header__pill-btn");
      if (!btn) return;

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = container.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });

    document.addEventListener("click", function (e) {
      document.querySelectorAll("[data-kj-dropdown].is-open").forEach(function (container) {
        if (!container.contains(e.target)) {
          container.classList.remove("is-open");
          var btn = container.querySelector(".kj-header__pill-btn");
          if (btn) btn.setAttribute("aria-expanded", "false");
        }
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        document.querySelectorAll("[data-kj-dropdown].is-open").forEach(function (container) {
          container.classList.remove("is-open");
          var btn = container.querySelector(".kj-header__pill-btn");
          if (btn) btn.setAttribute("aria-expanded", "false");
        });
      }
    });

    document.querySelectorAll("[data-kj-mobile-accordion]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest(".kj-mobile-group");
        if (group) group.classList.toggle("is-open");
      });
    });
  }

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    document.querySelectorAll("[data-kj-menu-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var nav = document.querySelector(btn.getAttribute("data-kj-menu-toggle"));
        if (nav) nav.classList.toggle("is-open");
      });
    });
  }

  /* ---------------- Accordions ---------------- */
  function initAccordions() {
    document.querySelectorAll("[data-accordion-group]").forEach(function (group) {
      var items = group.querySelectorAll(".kj-accordion-item");
      items.forEach(function (item) {
        var trigger = item.querySelector(".kj-accordion-trigger");
        if (!trigger) return;
        trigger.addEventListener("click", function () {
          var wasOpen = item.classList.contains("is-open");
          items.forEach(function (i) {
            i.classList.remove("is-open");
            var sign = i.querySelector(".kj-accordion-sign");
            if (sign) sign.textContent = "+";
            var t = i.querySelector(".kj-accordion-trigger");
            if (t) t.setAttribute("aria-expanded", "false");
          });
          if (!wasOpen) {
            item.classList.add("is-open");
            var sign = item.querySelector(".kj-accordion-sign");
            if (sign) sign.textContent = "–";
            trigger.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initProductGallery() {
    document.querySelectorAll("[data-kj-gallery]").forEach(function (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-slide-index]"));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-kj-thumb]"));
      var prevBtn = gallery.querySelector("[data-kj-gallery-prev]");
      var nextBtn = gallery.querySelector("[data-kj-gallery-next]");

      function currentIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains("is-active")) return i;
        }
        return 0;
      }

      function goTo(index) {
        var total = slides.length;
        // Wrap around
        index = ((index % total) + total) % total;
        slides.forEach(function (s, i) { s.classList.toggle("is-active", i === index); });
        thumbs.forEach(function (t, i) { t.classList.toggle("is-active", i === index); });
      }

      // Thumb clicks
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function () { goTo(i); });
      });

      // Arrow clicks
      if (prevBtn) prevBtn.addEventListener("click", function () { goTo(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { goTo(currentIndex() + 1); });
    });
  }

  /* ---------------- Variant picker + add to cart ---------------- */
  function initVariantPickers() {
    document.querySelectorAll("[data-kj-product-form]").forEach(function (root) {
      var dataEl = root.querySelector("[data-kj-product-json]");
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var optionInputs = root.querySelectorAll("[data-kj-option]");
      var idInput = root.querySelector("[data-kj-variant-id]");
      var priceEl = root.querySelector("[data-kj-price]");
      var comparePriceEl = root.querySelector("[data-kj-compare-price]");
      var stockEl = root.querySelector("[data-kj-stock]");
      var addBtn = root.querySelector("[data-kj-add-btn]");
      var buyNowBtn = root.querySelector("[data-kj-buynow-btn]");
      var form = root.querySelector("form[data-kj-cart-form]");

      function currentSelections() {
        var sel = [];
        var groups = {};
        optionInputs.forEach(function (btn) {
          var name = btn.getAttribute("data-option-name");
          if (btn.classList.contains("is-active")) groups[name] = btn.getAttribute("data-value");
        });
        product.options.forEach(function (optName) {
          sel.push(groups[optName]);
        });
        return sel;
      }

      function findVariant(sel) {
        return product.variants.find(function (v) {
          return v.options.every(function (val, i) { return val === sel[i]; });
        });
      }

      function money(cents) {
        var format = (window.kjMoneyFormat || "").replace(/Rs\.?/gi, "₹") || "₹{{amount}}";
        var str = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, format) : "₹" + (cents / 100).toFixed(2);
        return str.replace(/Rs\.?\s*/gi, "₹ ");
      }

      function refresh() {
        var sel = currentSelections();
        var variant = findVariant(sel);

        optionInputs.forEach(function (btn) {
          var name = btn.getAttribute("data-option-name");
          var val = btn.getAttribute("data-value");
          var testSel = sel.slice();
          var idx = product.options.indexOf(name);
          testSel[idx] = val;
          var exists = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === testSel[i]; });
          });
          btn.disabled = !exists;
        });

        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = money(variant.compare_at_price);
            comparePriceEl.classList.remove("kj-hidden");
          } else {
            comparePriceEl.classList.add("kj-hidden");
          }
        }
        if (addBtn) {
          if (!variant.available) {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute("data-sold-out-text") || "Sold out";
          } else {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute("data-add-text") || "Add to cart";
          }
        }
        if (buyNowBtn) {
          if (!variant.available) {
            buyNowBtn.disabled = true;
            buyNowBtn.textContent = buyNowBtn.getAttribute("data-sold-out-text") || "Sold out";
          } else {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = buyNowBtn.getAttribute("data-buynow-text") || "Buy now";
          }
        }
        if (stockEl) {
          stockEl.textContent = variant.available
            ? (stockEl.getAttribute("data-in-stock-text") || "In stock")
            : (stockEl.getAttribute("data-out-of-stock-text") || "Out of stock");
        }
        var mediaBtn = root.querySelector('[data-kj-thumb][data-variant-id="' + variant.id + '"]');
        if (mediaBtn) mediaBtn.click();
      }

      optionInputs.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var name = btn.getAttribute("data-option-name");
          root.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (b) {
            b.classList.remove("is-active");
          });
          btn.classList.add("is-active");
          refresh();
        });
      });

      if (buyNowBtn) {
        buyNowBtn.addEventListener("click", function (evt) {
          evt.preventDefault();
          if (buyNowBtn.disabled) return;
          var variantId = idInput ? idInput.value : null;
          if (!variantId && product && product.variants && product.variants[0]) {
            variantId = product.variants[0].id;
          }
          if (!variantId) return;

          var originalText = buyNowBtn.textContent;
          buyNowBtn.disabled = true;
          buyNowBtn.textContent = buyNowBtn.getAttribute("data-redirecting-text") || "Proceeding…";

          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1
            })
          })
            .then(function (res) {
              if (!res.ok) throw new Error("Add failed");
              return res.json();
            })
            .then(function () {
              window.location.href = "/checkout";
            })
            .catch(function () {
              window.location.href = "/cart/" + variantId + ":1";
            });
        });
      }

      if (form) {
        form.addEventListener("submit", function (evt) {
          evt.preventDefault();
          if (addBtn && addBtn.disabled) return;
          var formData = new FormData(form);
          var originalText = addBtn ? addBtn.textContent : "";
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute("data-adding-text") || "Adding…"; }
          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: formData
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              if (addBtn) addBtn.textContent = addBtn.getAttribute("data-added-text") || "Added to cart";
              document.dispatchEvent(new CustomEvent("kj:cart:added"));
              updateCartCount();
              setTimeout(function () {
                if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText || (addBtn.getAttribute("data-add-text") || "Add to cart"); }
              }, 2200);
            })
            .catch(function () {
              if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
            });
        });
      }

      refresh();
    });
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-kj-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------------- Collection controls (filter + sort) ---------------- */
  function initCollectionControls() {
    var grid = document.querySelector("[data-kj-collection-grid]");
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-kj-product-card]"));
    var chips = document.querySelectorAll("[data-kj-filter-chip]");
    var sortSelect = document.querySelector("[data-kj-sort-select]");
    var countEl = document.querySelector("[data-kj-count-label]");

    function applyFilter() {
      var active = document.querySelector("[data-kj-filter-chip].is-active");
      var type = active ? active.getAttribute("data-filter-value") : "all";
      var visibleCount = 0;
      cards.forEach(function (card) {
        var cardType = (card.getAttribute("data-product-type") || "").toLowerCase();
        var show = type === "all" || cardType === type.toLowerCase();
        card.classList.toggle("kj-hidden", !show);
        if (show) visibleCount++;
      });
      if (countEl) {
        var tpl = countEl.getAttribute("data-template") || "{{count}} objects";
        countEl.textContent = tpl.replace("{{count}}", visibleCount).replace("{{noun}}", visibleCount === 1 ? "object" : "objects");
      }
    }

    function applySort() {
      if (!sortSelect) return;
      var val = sortSelect.value;
      var sorted = cards.slice();
      if (val === "low") sorted.sort(function (a, b) { return parseFloat(a.getAttribute("data-price")) - parseFloat(b.getAttribute("data-price")); });
      if (val === "high") sorted.sort(function (a, b) { return parseFloat(b.getAttribute("data-price")) - parseFloat(a.getAttribute("data-price")); });
      if (val === "name") sorted.sort(function (a, b) { return (a.getAttribute("data-name") || "").localeCompare(b.getAttribute("data-name") || ""); });
      sorted.forEach(function (card) { grid.appendChild(card); });
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-active"); });
        chip.classList.add("is-active");
        applyFilter();
      });
    });
    if (sortSelect) sortSelect.addEventListener("change", applySort);

    applyFilter();
  }

  /* ---------------- Mood / energy picker ---------------- */
  function initMoodPicker() {
    document.querySelectorAll("[data-kj-mood-root]").forEach(function (root) {
      var buttons = root.querySelectorAll("[data-mood-btn]");
      var panels = root.querySelectorAll("[data-mood-panel]");
      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var mood = btn.getAttribute("data-mood-btn");
          buttons.forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          panels.forEach(function (p) {
            p.classList.toggle("is-active", p.getAttribute("data-mood-panel") === mood);
          });
        });
      });
    });
  }

  /* ---------------- Currency & Rupee normalization ---------------- */
  function normalizeRupeeSymbols() {
    var selectors = ".kj-card__price, .kj-mood-card__price, .kj-product__price, [data-kj-price], [data-kj-compare-price]";
    document.querySelectorAll(selectors).forEach(function (el) {
      if (el.childNodes && el.childNodes.length > 0) {
        el.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && node.nodeValue && /Rs\.?/i.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/Rs\.?\s*/gi, "₹ ");
          }
        });
      }
    });
  }

  /* ---------------- Cart Page AJAX Handler ---------------- */
  function initCartPage() {
    var cartSection = document.querySelector("[data-kj-cart-section]");
    if (!cartSection) return;

    var emptyEl = cartSection.querySelector("[data-kj-cart-empty]");
    var populatedEl = cartSection.querySelector("[data-kj-cart-populated]");
    var countLabel = cartSection.querySelector("[data-kj-cart-count-label]");
    var subtotalEl = cartSection.querySelector("[data-cart-subtotal]");
    var totalEl = cartSection.querySelector("[data-cart-total]");

    function formatMoney(cents) {
      var format = (window.kjMoneyFormat || "").replace(/Rs\.?/gi, "₹") || "₹{{amount}}";
      var str = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, format) : "₹" + (cents / 100).toFixed(2);
      return str.replace(/Rs\.?\s*/gi, "₹ ");
    }

    function updateCartUI(cart) {
      if (cart.item_count === 0) {
        if (populatedEl) populatedEl.classList.add("kj-hidden");
        if (emptyEl) emptyEl.classList.remove("kj-hidden");
      } else {
        if (emptyEl) emptyEl.classList.add("kj-hidden");
        if (populatedEl) populatedEl.classList.remove("kj-hidden");
        if (countLabel) countLabel.textContent = "(" + cart.item_count + ")";
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

        cart.items.forEach(function (item) {
          var row = cartSection.querySelector('[data-line-item-key="' + item.key + '"]');
          if (row) {
            row.querySelectorAll("[data-line-total]").forEach(function (el) {
              el.textContent = formatMoney(item.final_line_price);
            });
            row.querySelectorAll(".kj-qty-input").forEach(function (input) {
              input.value = item.quantity;
            });
          }
        });
      }
      updateCartCount();
      normalizeRupeeSymbols();
    }

    var isUpdating = false;
    function changeQuantity(lineKey, newQty, itemRow) {
      if (isUpdating) return;
      isUpdating = true;

      if (newQty <= 0 && itemRow) {
        itemRow.classList.add("is-removing");
      }

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: newQty
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          isUpdating = false;
          if (newQty <= 0 && itemRow) {
            itemRow.remove();
          }
          updateCartUI(cart);
        })
        .catch(function (err) {
          isUpdating = false;
          if (itemRow) itemRow.classList.remove("is-removing");
          console.error("Cart update error:", err);
        });
    }

    cartSection.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-qty-change]");
      if (btn) {
        e.preventDefault();
        var delta = parseInt(btn.getAttribute("data-qty-change"), 10);
        var container = btn.closest("[data-kj-qty-control]");
        var input = container ? container.querySelector(".kj-qty-input") : null;
        if (!input) return;
        var lineKey = input.getAttribute("data-line-key");
        var currentQty = parseInt(input.value, 10) || 0;
        var newQty = Math.max(0, currentQty + delta);
        input.value = newQty;
        var itemRow = btn.closest(".kj-cart-item");
        changeQuantity(lineKey, newQty, itemRow);
        return;
      }

      var removeBtn = e.target.closest("[data-cart-remove]");
      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.getAttribute("data-cart-remove");
        var row = removeBtn.closest(".kj-cart-item");
        changeQuantity(key, 0, row);
      }
    });

    cartSection.addEventListener("change", function (e) {
      if (e.target.classList.contains("kj-qty-input")) {
        var input = e.target;
        var lineKey = input.getAttribute("data-line-key");
        var newQty = Math.max(0, parseInt(input.value, 10) || 0);
        var itemRow = input.closest(".kj-cart-item");
        changeQuantity(lineKey, newQty, itemRow);
      }
    });
  }
})();
